import getStore from '../store/store';
import { isFolderPaused } from 'owa-mail-list-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { getLogicalRing } from 'owa-config';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';

const FAVICON_RELATIVE_PATH = 'resources/images/favicons';
const MAIL_SEEN_FAVICON = `${FAVICON_RELATIVE_PATH}/mail-seen.ico`;
const MAIL_UNSEEN_FAVICON = `${FAVICON_RELATIVE_PATH}/mail-unseen.ico`;
const OUTLOOK_DOGFOOD_ICON = `${FAVICON_RELATIVE_PATH}/outlook-beta.ico`;
const OUTLOOK_MICROSOFT_ICON = `${FAVICON_RELATIVE_PATH}/outlook-msit.ico`;

export default function mailFaviconProvider(): string {
    var mailSeenIcon: string = MAIL_SEEN_FAVICON;

    if (isHostAppFeatureEnabled('updateHostAppIcon')) {
        mailSeenIcon = getDefaultMonarchIcon();
    }

    return getStore().unseenMessages === 0 || isFolderPaused(folderNameToId('inbox'))
        ? mailSeenIcon
        : MAIL_UNSEEN_FAVICON;
}

function getDefaultMonarchIcon(): string {
    switch (getLogicalRing()) {
        case 'Dogfood':
            return OUTLOOK_DOGFOOD_ICON;
        case 'Microsoft':
            return OUTLOOK_MICROSOFT_ICON;
        default:
            return MAIL_SEEN_FAVICON;
    }
}
